import React from "react";

export function AppUploadLayout() {
  return <div>AppUploadLayout</div>;
}
